<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import SearchPage from './pages/SearchPage';
import VueRouter from 'vue-router';
import Vue from 'vue';

Vue.use(VueRouter);

const routes = [
  { path: '/', redirect: 'search' },
  { path: '/search', component: SearchPage }
];
const router = new VueRouter({
  routes,
  mode: 'history'
});

export default {
  name: 'app',
  router,
  components: {
    SearchPage
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue